/* Reseñas: orden + paginacion + lightbox */
(function () {
  function init(root) {
    if (root.dataset.mlbrReady === '1') return;
    root.dataset.mlbrReady = '1';

    var list = root.querySelector('[data-mlbr-list]');
    var sel = root.querySelector('[data-mlbr-sort]');
    var pager = root.querySelector('[data-mlbr-pager]');
    if (!list) return;

    var perPage = parseInt(list.dataset.perPage, 10) || 4;
    var items = [].slice.call(list.querySelectorAll('[data-mlbr-item]'));
    items.forEach(function (el, i) { el.dataset.orden = i; });

    var orden = items.slice();
    var page = 1;

    function totalPages() { return Math.ceil(orden.length / perPage) || 1; }

    function pintarLista() {
      orden.forEach(function (el) { list.appendChild(el); });
      var ini = (page - 1) * perPage;
      orden.forEach(function (el, i) { el.hidden = (i < ini || i >= ini + perPage); });
    }

    function pintarPager() {
      if (!pager) return;
      pager.innerHTML = '';
      var n = totalPages();
      if (n < 2) return;

      var nums = [];
      if (n <= 6) {
        for (var i = 1; i <= n; i++) nums.push(i);
      } else {
        nums = [1, 2, 3, 4, '...', n];
      }

      nums.forEach(function (v) {
        if (v === '...') {
          var s = document.createElement('span');
          s.className = 'mlbr__gap';
          s.textContent = '…';
          pager.appendChild(s);
          return;
        }
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'mlbr__pagebtn' + (v === page ? ' is-active' : '');
        b.textContent = v;
        b.addEventListener('click', function () {
          page = v;
          pintarLista();
          pintarPager();
          root.scrollIntoView({ block: 'start', behavior: 'smooth' });
        });
        pager.appendChild(b);
      });
    }

    if (sel) {
      sel.addEventListener('change', function () {
        var modo = sel.value;
        orden = items.slice();
        if (modo === 'alta') {
          orden.sort(function (a, b) {
            var d = parseFloat(b.dataset.rating) - parseFloat(a.dataset.rating);
            return d !== 0 ? d : a.dataset.orden - b.dataset.orden;
          });
        } else if (modo === 'baja') {
          orden.sort(function (a, b) {
            var d = parseFloat(a.dataset.rating) - parseFloat(b.dataset.rating);
            return d !== 0 ? d : a.dataset.orden - b.dataset.orden;
          });
        }
        page = 1;
        pintarLista();
        pintarPager();
      });
    }

    var lb = document.querySelector('[data-mlbr-lb]');
    if (lb) {
      var lbImg = lb.querySelector('[data-mlbr-lbimg]');
      root.querySelectorAll('[data-mlbr-pic]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var full = btn.dataset.full;
          if (!full || !lbImg) return;
          lbImg.src = full;
          lb.hidden = false;
          document.documentElement.style.overflow = 'hidden';
        });
      });
      if (!lb.dataset.bound) {
        lb.dataset.bound = '1';
        lb.querySelectorAll('[data-mlbr-lbclose]').forEach(function (b) {
          b.addEventListener('click', function () {
            lb.hidden = true;
            document.documentElement.style.overflow = '';
          });
        });
        document.addEventListener('keydown', function (e) {
          if (e.key === 'Escape' && !lb.hidden) {
            lb.hidden = true;
            document.documentElement.style.overflow = '';
          }
        });
      }
    }

    pintarLista();
    pintarPager();
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-mlbr]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
